import { ContainerErrorType } from '@fluidframework/container-definitions';
import { DriverErrorType } from '@fluidframework/driver-definitions';
import { OdspErrorType } from '@fluidframework/odsp-doclib-utils';

export type OfficeFluidErrorType = OWHErrorType | ContainerErrorType | DriverErrorType | OdspErrorType | 'unknownError';

export enum OWHErrorType {
  /**
   * The IFrame failed to initialize
   */
  IframeLoadFailed = 'IframeLoadFailed',

  /**
   * Loaded container version is no longer valid and needs upgrade
   *
   * TODO: Consider promoting ContainerUpgradeRequired to FF and expose it via ErrorType
   */
  ContainerUpgradeRequired = 'ContainerUpgradeRequired'
}

export type OWHError = ContainerUpgradeRequiredError;

export class OWHErrorBase extends Error {
  constructor(message: string, name: OWHErrorType, readonly internalError?: any) {
    super(message);
    this.name = name;
  }
}

/**
 * Error class used to communicate that the IFrame service failed to initialize.
 * (Ex: message protocols inside and outside were incompatible)
 */
export class IframeLoadFailedError extends OWHErrorBase {
  constructor(message: string, internalError?: any) {
    super(message, OWHErrorType.IframeLoadFailed, internalError);
  }
}

/**
 * Error class used to communicate that loaded container version is no longer and needs upgrade
 *
 * TODO: Consider promoting ContainerUpgradeRequired to FF and expose it via ErrorType
 */
export class ContainerUpgradeRequiredError extends OWHErrorBase {
  constructor(message: string, internalError?: any) {
    super(message, OWHErrorType.ContainerUpgradeRequired, internalError);
  }
}
